import { createApp } from "vue";
import "./index.css";

// eslint-disable-next-line import/no-extraneous-dependencies
import Particles from "@tsparticles/vue3";

import { loadSlim } from "@tsparticles/slim";
import App from "./App.vue";
// eslint-disable-next-line import/no-unresolved, import/extensions
import router from "./router";

declare module "@tsparticles/vue3";

const app = createApp(App);
app.use(router);
app.use(Particles, {
  init: async (engine) => {
    await loadSlim(engine);
  },
});
router.isReady().then(() => {
  app.mount("#app");
});
